import { PText } from "@porsche-design-system/components-react"
import type { BasicPricingValues } from "@slfinrtl/ui-bff-routes"
import { FormattedMessage } from "react-intl"
import { commonMessages } from "src/common/messages/common.messages"
import { pricingFieldMessages } from "src/components"
import { useConfig } from "src/hooks"
import { FieldWrapper } from "../FieldWrapper"

interface PricingChangeView {
	pricing?: Partial<BasicPricingValues> // just vatDeductible is relevant
}

export interface PricingChangesProps {
	view: PricingChangeView
}

export const PricingChanges = ({ view }: PricingChangesProps) => {
	const { pricing } = view
	const { vatDeductibleAvailable } = useConfig()

	return (
		vatDeductibleAvailable &&
		pricing?.vatDeductible !== undefined && (
			<FieldWrapper>
				<PText>
					<FormattedMessage {...pricingFieldMessages.vatDeductibleLabel} />
				</PText>
				<PText>
					<FormattedMessage {...(pricing.vatDeductible ? commonMessages.yes : commonMessages.no)} />
				</PText>
			</FieldWrapper>
		)
	)
}
